import React from 'react';
import MainHeader from './mainHeader';

class RelatedAddressHeader extends React.Component {
    render() {
        return (<MainHeader label="Report.Relations.RelatedAddresses.SectionName" shadowed={true} {...this.props} />)
    }
}

export default RelatedAddressHeader;